\rentware-image
    width: 100%
    height: 100%
    display: flex
    justify-content: center
    align-items: center

    #one-pix-image
        width: 100%
        height: 100%
        background: rgb($globalSettingsBackgroundTertiary)
        cursor: default !important
